import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-footer" }
const _hoisted_2 = { class: "footer-container" }
const _hoisted_3 = { class: "features-content" }
const _hoisted_4 = { class: "feature-item" }
const _hoisted_5 = { class: "icon-wrapper" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "feature-item" }
const _hoisted_8 = { class: "icon-wrapper" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "feature-item" }
const _hoisted_11 = { class: "icon-wrapper" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "feature-item" }
const _hoisted_14 = { class: "icon-wrapper" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "footer-bottom" }
const _hoisted_17 = { class: "footer-bottom-container" }

import { computed } from 'vue'

import { useTheme } from '@/composables/useTheme'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'AppFooter'
},
  __name: 'AppFooter',
  setup(__props) {



const { getAssetPath } = useTheme()

const footerDraws = computed(() => getAssetPath('footer', 'draws') || '/img/images/footer/01-draws.png')
const footerGlobalLotteries = computed(() => getAssetPath('footer', 'globalLotteries') || '/img/images/footer/02-global-lotteries.png')
const footerGreatMarkets = computed(() => getAssetPath('footer', 'greatMarkets') || '/img/images/footer/03-great-markets.png')
const footerFastResults = computed(() => getAssetPath('footer', 'fastResults') || '/img/images/footer/04-fast-results.png')

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "info-grid" }, [
        _createElementVNode("div", { class: "info-section" }, [
          _createElementVNode("h2", null, "SELECT YOUR DRAW"),
          _createElementVNode("p", null, " We welcome you to register and choose from our extensive list of international Lucky Numbers draws. Numerous Lucky Numbers draws take place on a daily basis offering you the chance to win every day of the week. To begin, select which draw you would like to play by clicking on the \"BET NOW\" button. ")
        ]),
        _createElementVNode("div", { class: "info-section" }, [
          _createElementVNode("h2", null, "CHOOSE YOUR WINNING NUMBER"),
          _createElementVNode("p", null, " You can improve your odds by choosing to predict the outcome of 1, 2, 3 or 4 numbers from a draw from the \"BET TYPE\" option. You can also bet on the outcome of the bonus ball in some draws. Select the numbers you wish to choose for your prediction according to your chosen \"BET TYPE\". ")
        ]),
        _createElementVNode("div", { class: "info-section" }, [
          _createElementVNode("h2", null, "SUBMIT YOUR BET"),
          _createElementVNode("p", null, " Enter the amount of money you would like to bet with and submit your bet. Your wager history will display all your wagers and winnings. Also, all the draw results are displayed on this site for your convenience! ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: footerDraws.value,
              alt: "Fast",
              width: "60",
              height: "60"
            }, null, 8, _hoisted_6)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("h3", null, "Widest Selection", -1))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: footerGlobalLotteries.value,
              alt: "Lucky Numbers",
              width: "60",
              height: "60"
            }, null, 8, _hoisted_9)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("h3", null, "Global Lucky Numbers", -1))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              src: footerGreatMarkets.value,
              alt: "Great Markets",
              width: "60",
              height: "60"
            }, null, 8, _hoisted_12)
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Great Markets", -1))
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", {
              src: footerFastResults.value,
              alt: "Fast Results",
              width: "60",
              height: "60"
            }, null, 8, _hoisted_15)
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Fast Results", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_router_link, {
          to: "/terms-and-conditions",
          class: "footer-bottom-link"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("Terms & Conditions")
          ])),
          _: 1
        }),
        _cache[7] || (_cache[7] = _createTextVNode(" | ")),
        _createVNode(_component_router_link, {
          to: "/wagers",
          class: "footer-bottom-link"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode("Wagers")
          ])),
          _: 1
        }),
        _cache[8] || (_cache[8] = _createTextVNode(" | ")),
        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "footer-bottom-version" }, "Version: 1.0.1", -1))
      ])
    ])
  ]))
}
}

})